export default "__VITE_ASSET__dc1001d5__"